import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { DevedorService } from 'app/services';
import { DetalheBaseController } from 'app/helpers';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { CpfCnpjPipe } from 'app/shared/pipes/cpfCnpj.pipe';
import * as _ from 'underscore';

@Component({
  selector: 'app-cartaQuitacao',
  templateUrl: './carta-quitacao.component.html'
})
export class CartaQuitacaoComponent extends DetalheBaseController implements OnInit {
  @Input() usuario: any;
  @Input() acordo: any;
  @Input() telefonesClienteCobranca: any;
  ClientesCobranca = [];
  dataCartaQuitacao: any = moment().locale('pt-br').format('LL');
  subCliente: Subscription;
  quitacao: any = {};

  constructor(private router: Router, route: ActivatedRoute, private _devedor: DevedorService, private currencyPipe: CurrencyPipe, private cpfCnpjPipe: CpfCnpjPipe) {
    super(route, _devedor);
  }

  ngOnInit() {    
    let somaValorOriginal = this.acordo.acordoDivida.acordoComposicao.reduce((s, f) => {
      return s + f.valorOriginal;               
    }, 0);                               
    let somaValorCobrado = this.acordo.acordoDivida.acordoComposicao.reduce((s, f) => {
      return s + f.valorPrincipalCobrado;               
    }, 0);
  
    this.quitacao.usuario = this.usuario;
    this.quitacao.cpfCnpjFormatado = this.cpfCnpjPipe.transform(this.usuario.cpfCnpj, "");
    this.quitacao.telefonesClienteCobranca  = this.telefonesClienteCobranca;   
    this.quitacao.valorTotalAcordoFormatado = this.currencyPipe.transform(this.acordo.valorTotalAcordo, 'BRL', true);
    this.quitacao.valorTotalDividaFormatado = this.currencyPipe.transform(this.acordo.acordoDivida.valorTotalAcordo, 'BRL', true);
    this.quitacao.valorOriginalDivida = this.currencyPipe.transform(somaValorOriginal, 'BRL', true);
    this.quitacao.valorDesconto = this.currencyPipe.transform(somaValorOriginal - somaValorCobrado, 'BRL', true);
    this.quitacao.comDesconto = somaValorOriginal - somaValorCobrado > 0 ? true : false;
  }
 
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/carta-quitacao/carta-quitacao.component.ts